import React, { useEffect, useState } from "react";
import { Tooltip } from 'react-tooltip';
import ImageWithFallback from "common/components/ImageWithFallback/ImageWithFallback";
import app_params from "modules/search/config/params";
import ShareModal from "../ShareModal/ShareModal";
import { searchResultDummy } from "modules/search/dummy/searchresult";
import styles from "./SearchResultItem.module.scss";
import Axios from 'services/BackendApi/BackendApi';
import image from 'assets/icono.jpg'
import RecordView from "modules/catalog/views/RecordView/RecordView"
import { FaCheck, FaGlobeAmericas, FaTimes } from "react-icons/fa";
import ItemModals from "./ItemModals/ItemModals";
import QuoteModal from "../QuoteModal/QuoteModal";
import Modal from 'react-bootstrap/Modal';
import { OverlayTrigger } from 'react-bootstrap';
import { Button } from "react-bootstrap";
import GlifosDigitalArchiveViewer from 'modules/catalog/components/GlifosDigitalArchiveViewer/GlifosDigitalArchiveViewer'

const recordDownload = async (record, file) => {
  window.open(file, "_blank");
};



const SearchResultItem = (props) => {
  const { item, searchargs, docs, ids } = props;
  // const result_header =  searchargs;
  const [docytpes, setDoctypes] = useState([]);
  const [show, setShow] = useState(false);
  const [showDocumente, setShowDocument] = useState(false);
  const [identifiers, setIdentifiers] = useState([]);
  const bearer = localStorage.getItem("userInfo");
  const token = JSON.parse(bearer).access_token;
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [texto, setTexto] = useState("Ver Documento");
  // const [selectedItems, setSelectedItems] = useState({});
  const handleClose = () => setShow(false);

  const handleShow = () => {
    window.location.href = `${app_params.basepath}/view/${true}/${item?.title}?${searchargs.replace("?", "")}`
  };

  // var prueba = item.typefiedid
  // console.log(item)
  useEffect(() => {
    if (item) {
      if (item?.thumbnail.split('/')[5] == "") {
        // console.log("entre")
        setDeshabilitado(true)
        setTexto("No tiene Documento")
      }
    }
    // formatearIds("bank-account-313-005439-5 bank-document-id-137002 SAP_ERP_number-137002")
  }, []);

  function buscarNombrePorCodigo(codigo) {
    const elemento = docs.find(item => item.code === codigo);
    return elemento ? elemento.name : codigo;
  }

  function obtenerCodigoEmpresa(name) {
    const elemento = name.split("-");
    if (elemento[0] == "GT") {
      return elemento[0] + "-" + elemento[1]
    }
    return elemento[0]
  }



  function formatearIds(ids) {
    if (!ids) {
      return <>
      </>
    }
    var datos = ""
    try {
      datos = ids?.replaceAll(" ", ",");
    } catch (error) {

    }
    const arreglo = datos.split(",");
    let new_array = arreglo.filter(elemento => !elemento.includes("reference"));
    return (
      <div>
        {new_array.slice(0, 6).map((elemento, index) => (
          <div key={index}>
            <b>
              {obtenerNombre(elemento)[0]}:
            </b>
            {obtenerNombre(elemento)[1]}
            <br />
          </div>
        ))}
        {(arreglo.length > 6) ? <b>...</b> : ''}
      </div>
    );
  }


  function obtenerNombre(texto) {
    let res = texto;
    let array = [];
    for (let item of ids) {
      let regex = new RegExp(item.code, 'gi');
      res = res.replace(regex, item.name);
      array = res.replace("-", ":");
      array = array.split(":");
    }
    return array;
  }


  return (

    <div className={`${styles.card_container} bg-white shadow-sm rounded`} data-tooltip-id={`tooltip-${item.id}`} key={item?.id}>
    <a href={`${app_params.basepath}/view/${false}/${item?.title}?${searchargs.replace("?", "")}`}
      style={{ textDecoration: 'none' }}>
      <div className="row">
        <div className="col-4 d-flex align-items-center">
          <div className="row" >
            <a href={`${app_params.basepath}/view/${false}/${item?.title}?${searchargs.replace("?", "")}`}
              className={`text-decoration-none d-flex align-items-center ${styles.item_title}`}>
              <div className="col-12">
                <ImageWithFallback
                  fallback={image}
                  src={"/api/v1/file/get-thumbnail/" + item?.thumbnail.split('/')[5]}
                  token={token}
                  className={`img-fluid rounded-start`}
                />
              </div>
            </a>
          </div>
        </div>

        <div className="col-8">
          <div className="p-3">
            <a
              href={`${app_params.basepath}/view/${false}/${item?.title}?${searchargs.replace("?", "")}`}
              className={`text-decoration-none ${styles.item_title}`}
            >
              {item?.title}

              <br />
            </a>
            <a href={`${app_params.basepath}/view/${false}/${item?.title}?${searchargs.replace("?", "")}`}
              className={`text-decoration-none ${styles.item_description}`}>
              <div className="col-12 pt-4">
                {item?.title && (
                  <div>
                    <b>Empresa :</b> {obtenerCodigoEmpresa(item.title)}
                    <br />
                  </div>
                )}
                {item?.doctype && (
                  <>
                    <b>Tipo de Documento : </b>{item.doctype}-{buscarNombrePorCodigo(item.doctype)}
                    <br />
                  </>
                )}
              </div>
            </a>

            <div className="col-12 col-lg-10">
              {item?.available === "true" &&
                item?.repositoryType === "GLIFOS" && (
                  <span className="badge roudend-pill bg-success">
                    <FaCheck /> Disponible
                  </span>
                )}
              {item?.available === "false" &&
                item?.repositoryType === "GLIFOS" && (
                  <span className="badge roudend-pill bg-danger">
                    <FaTimes /> No disponible
                  </span>
                )}
              <br />
              {item?.digital && (
                <button
                  className="btn btn-primary mt-2"
                  onClick={() => recordDownload(item?.id, item?.digital)}
                >
                  <span className="me-2">
                    <FaGlobeAmericas />
                  </span>
                  En línea
                </button>
              )}

              <div className="d-flex justify-content-center"> 
                {(!deshabilitado) ?
                  <Button className={styles.button} onClick={(event) => { event.stopPropagation();
                    event.preventDefault(); 
                    handleShow(item?.title)}}>Ver Documento</Button>
                  :
                  null
                }  
              </div> 
            </div>
          </div>
          
        </div>
          {/* <ItemModals id={item?.id} /> */}
      </div>
      </a>

      <Tooltip id={`tooltip-${item.id}`} place="top" effect="solid" strategy="fixed" className={styles.tooltip_custom}>
        Identificadores: {formatearIds(item.typefiedid)}
      </Tooltip>

      {/* <QuoteModal modalID={`quoteModal-${item?.id}`} item={item} /> */}
      {/* <ShareModal
        id={`shareModal-${item?.id}`}
        url={`${window.location.origin}${app_params.basepath}/record/${item?.id
          }?${encodeURI(result_header?.searchargs)}${encodeURI(searchargs)}`}
        quote={item?.title}
      /> */}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{item?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <GlifosDigitalArchiveViewer src={"/api/v1/file/get-file/" + item?.thumbnail.split('/')[5]} token={token} />
        </Modal.Body>
      </Modal>
      </div>
  );
};

export default SearchResultItem;
